module.exports = __webpack_public_path__ + "static/media/messages3.32a7a0de.png";